import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import { _3_DAYS } from '../../../constants/durations';
import type { SpaceMemberWithProfile } from '../types';
import { keys } from './keys';

async function fetchSpaceMembers(spaceId: string) {
  const { data, error } = await apiClient
    .from('space_members')
    .select(`
      *,
      profiles (first_name, last_name),
      user_basic_info (email)
    `)
    .eq('space_id', spaceId)
    .order('created_at', { ascending: true });

  if (error) {
    throw error;
  }

  return data as unknown as SpaceMemberWithProfile[];
}

export default function useGetSpaceMembers(spaceId: string | undefined) {
  return useQuery({
    queryKey: keys.members(spaceId ?? ''),
    queryFn: () => fetchSpaceMembers(spaceId!),
    enabled: !!spaceId,
    staleTime: _3_DAYS,
  });
}
